<template>
  <v-row dense>
    <v-overlay :absolute="true" :value="loading">
      <v-row align="center" justify="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-col cols="12" sm="4" align-self="center">
      <v-text-field
        filled
        dense
        class="no-before"
        v-model="data.name"
        label="Nom"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="3" align-self="center">
      <j-decimal-input
        label="Marge de perte"
        :value="data.ratio * 100"
        @change="ratioChangeHandler"
        :min="0"
        :step="1"
        suffix="%"
        filled
        dense
        class="no-before"
      ></j-decimal-input>
    </v-col>
    <v-col cols="12" sm="4">
      <v-checkbox
        style="margin-top: 10px;"
        dense
        v-model="data.is_subtraction"
        label="Soustraire des ventes"
      ></v-checkbox>
    </v-col>
    <v-col cols="12" sm="1">
      <v-row align="center" justify="end" no-gutters>
        <v-btn icon text @click="save" :disabled="isValid === false">
          <v-icon color="success">fa-save</v-icon>
        </v-btn>
        <v-btn v-if="optionalValueExist" icon text @click="del">
          <v-icon color="error">fa-ban</v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SaleOptionalValueConfig",
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getSaleOptionalValues"]),
    isValid() {
      let v = true;
      if (this.data.name === null) v = false;
      if (this.data.ratio < 0) v = false;
      return v;
    },
    optionalValueExist() {
      const d = this.getSaleOptionalValues.find(
        x => x.value_number === this.index
      );
      return d !== undefined;
    }
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      loading: true,
      data: {
        name: null,
        ratio: 0,
        is_subtraction: true
      }
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const d = this.getSaleOptionalValues.find(
          x => x.value_number === this.index
        );
        if (d !== undefined) {
          this.data = d;
        } else {
          this.data = {
            name: null,
            ratio: 0,
            is_subtraction: true,
            value_number: this.index,
            store: this.getStoreId
          };
        }
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        this.loading = true;
        const d = this.data;
        if (d.id !== undefined && d.id !== null) {
          await this.$store.dispatch("updateSaleOptionalValue", d);
        } else {
          await this.$store.dispatch("addSaleOptionalValue", d);
        }
      } finally {
        this.getData();
        this.loading = false;
      }
    },
    async del() {
      try {
        this.loading = true;
        const d = this.data;
        if (d.id !== undefined && d.id !== null) {
          await this.$store.dispatch("deleteSaleOptionalValue", d);
        }
      } finally {
        this.getData();
        this.loading = false;
      }
    },
    ratioChangeHandler(v) {
      this.data.ratio = v / 100;
    }
  }
};
</script>

<style></style>
